<template>

    <div class="dataDeletion-container" v-wechat-title="'資料刪除'">
        <!--頂部欄-->
        <div class="top-nav-container">
            <span>資料刪除</span>
            <span @click="backClick" style="position: absolute;left: 10px">返回</span>
        </div>

        <div class="content-container">
            <p>
                尊敬的立異用戶：</p>
            <p>
                如果您想要刪除您的立異賬戶，請將您的賬戶資料發送email至mysteryread2017@gmail.com。</p>
            <p>
                工作人員回覆後，在7到14個工作天內，會將您的立異帳戶刪除。</p>
            <p>
                感謝！</p>
        </div>
    </div>

</template>

<script>
export default {
    name: "PrivacyPolicyVue",
    data() {
        return {};
    },

    methods: {
        //返回
        backClick: function () {
            this.$router.go(-1);
        },
    },

    created() {},
};
</script>

<style scoped>
.dataDeletion-container {
    max-width: 480px;
    min-height: 100vh;
    margin: 0 auto;
    border: 1px solid lightgoldenrodyellow;
    background-color: white;
}

.content-container {
    margin-top: 70px;
    text-align: left;
    margin-left: 10px;
    margin-right: 10px;
}

.content-container p {
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/DataDeletionVue.vue